import { create } from "zustand"

export type ActiveScriptSessionKind = "pattern" | "script"

interface ActiveScriptSession {
  companionId: string
  companionName: string
  /** The action tag used to trigger this — a builtin pattern id, or an
   * assigned Pal/community script's action tag. */
  tag: string
  /** Human-friendly display name — resolved from the builtin pattern
   * library when kind is 'pattern', otherwise a humanized version of the
   * tag itself. */
  label: string
  kind: ActiveScriptSessionKind
}

interface ActiveScriptSessionState {
  session: ActiveScriptSession | null
  start: (session: ActiveScriptSession) => void
  clear: () => void
}

/** Tracks which pattern/script is the "live" session for the current chat —
 * set by useScriptTriggerDispatch whenever a [[SCRIPT: tag]] AI trigger or a
 * manual pick from DeviceControlPopover actually starts playing, cleared on
 * Stop. Deliberately a standalone store (not local hook state) because
 * ScriptSessionPanel is a sibling of whatever triggered the session, not a
 * parent/child — chat-interface.tsx, app/glym/page.tsx, and
 * device-control-popover.tsx each hold their own useScriptTriggerDispatch()
 * instance, so this is the one shared place a third component can read
 * "is something playing right now, and what." */
export const useActiveScriptSessionStore = create<ActiveScriptSessionState>((set) => ({
  session: null,
  start: (session) => set({ session }),
  clear: () => set({ session: null }),
}))
